import { isUndefined, find, each } from 'underscore';
import isMobile from 'ismobilejs';
import Cookies from 'js-cookie';

(function () {
  angular.module('7Shop.Core')
    .provider('ShopEnvironment', ShopEnvironmentProvider);

  function ShopEnvironmentProvider($windowProvider) {
    var self = this;
    var states = {
      touch: false
    };

    const supportedLanguages = {
      en: {
        path: 'en-US'
      },
      bs: {
        path: 'hr'
      },
      de: {
        path: 'de'
      },
      sr: {
        path: 'sr-Latn'
      },
      srLatn: {
        path: 'sr-Latn'
      },
      srCyrl: {
        path: 'sr-Latn'
      },
      sk: {
        path: 'sk'
      },
      ro: {
        path: 'ro'
      },
      hr: {
        path: 'hr'
      },
      es: {
        path: 'es'
      },
      it: {
        path: 'it'
      },
      tr: {
        path: 'tr'
      },
      pl: {
        path: 'pl'
      },
      me: {
        path: 'me'
      },
      el: {
        path: 'el'
      },
      bg: {
        path: 'bg'
      },
      pt: {
        path: 'pt'
      },
      ru: {
        path: 'ru'
      },
      cs: {
        path: 'cs'
      },
      ka: {
        path: 'ka'
      },
      hu: {
        path: 'hu'
      },
      ke: {
        path: 'ke'
      },
      fr: {
        path: 'fr'
      },
      sl: {
        path: 'sl'
      },
      mkLatn: {
        path: 'mk-Latn'
      },
      mkCyrl: {
        path: 'mk-Latn'
      },
      sq: {
        path: 'sq'
      },
      ht: {
        path: 'ht'
      },
      st: {
        path: 'st'
      },
      sw: {
        path: 'sw'
      },
      id: {
        path: 'id'
      },
      vi: {
        path: 'vi'
      },
      zh: {
        path: 'zh'
      },
      th: {
        path: 'th'
      },
      uk: {
        path: 'uk'
      },
      lv: {
        path: 'lv'
      },
      ko: {
        path: 'ko'
      },
      km: {
        path: 'km'
      }
    };
    this.dc = null;
    this.language = null;

    function getUrlParameter(name) {
      var $ngWindow = $windowProvider.$get();
      var regex;
      var results;
      name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
      regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      results = regex.exec($ngWindow.location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    /**
     * @param {String} newDc
     */
    this.setDc = function (newDc) {
      this.dc = newDc;
    };

    /**
     * @return {String | null}
     */
    this.getDc = function () {
      return this.dc;
    };

    this.setLanguage = function (newLang) {
      this.language = newLang;
    };

    this.getLanguage = function () {
      return this.language;
    };

    this.getLocalePath = function () {
      var locale = supportedLanguages[this.language || 'en'];
      if (!locale) { locale = supportedLanguages.en; }

      return locale.path;
    };

    this.setState = function (state, value) {
      states[state] = value;
    };

    this.getState = function (state) {
      return states[state];
    };

    this.isDebugMode = function () {
      const debugModeParam = (getUrlParameter('logLevel') === 'debug')
      || getUrlParameter('debugMode')
      || localStorage.getItem('settings.logLevel');
      const debugMode = !isUndefined(debugModeParam) ? debugModeParam : false;
      return debugMode;
    };

    this.$get = function (
      $window,
      GravitySettings
    ) {
      this.isInTouchMode = function () {
        var forceTouchScreen = JSON.parse(localStorage.getItem('forceTouch'));
        if (forceTouchScreen) return true;
        return getUrlParameter('deviceType') === 'touch'
        || (GravitySettings.getModuleDataKeyValue('module.touch', 'autoDetect') && isMobile.any)
        || (GravitySettings.getModuleDataKeyValue('module.touch', 'forceTouch'));
      };

      this.isNativeTouch = function () {
        return getUrlParameter('deviceType') === 'touch' || isMobile.any;
      };

      /**
       * Set app channel
       * @param {string} betshopId
       * @param {string} deviceId
       * @returns {Boolean} - It will return true if app channel is changed
       */
      this.setChannel = function (betshopId, deviceId) {
        const noredirect = localStorage.getItem('s_noredirect') !== null || getUrlParameter('noredirect');
        var availableChannels = GravitySettings.getByKey('channels');
        var channelConfig = GravitySettings.getByKey('channel');
        var channelName = channelConfig.default;
        var overrideChannel = false;
        var foundChannel;

        // don't do any redirects if we are on localhost
        if ($window.location.hostname === 'localhost' || noredirect) {
          return false;
        }

        // it is possible to override default channel per betshop or device
        if (channelConfig.override) {
          overrideChannel = find(channelConfig.override, function (override) {
            return override.id === betshopId || override.id === deviceId;
          });

          if (overrideChannel) {
            channelName = overrideChannel.channel;
          }
        }

        // find channel url
        foundChannel = find(availableChannels.list, function (cha) {
          return cha.id === channelName;
        });

        // If current cookie does not have value of the curret channel, lets update it.
        // We will skip setting of channel if we are alredy on that URL (just to prevent unecessery reload)
        // See calling context.
        if (foundChannel && !Cookies.get(`s_channel_${foundChannel.id}`)
          && foundChannel.url.indexOf($window.location.origin) === -1) {
          // first remove any previous channel entires
          each(Cookies.get(), (value, key) => {
            if (key.indexOf('s_channel') !== -1) {
              // remove
              Cookies.remove(key);
            }
          });
          Cookies.set(`s_channel_${foundChannel.id}`, true, { expires: 2147483647 });
          return true;
        }

        return false;
      };

      this.getLogLevel = () => {
        const url = new URL($window.location.href);
        const level = url.searchParams.get('logLevel')
          || localStorage.getItem('settings.logLevel')
          || GravitySettings.getModuleDataKeyValue('application', 'logLevel')
          || 'warn';
        return level;
      };

      angular.extend(this, self);
      return self;
    };
  }
})();
